import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgYesGlyphSecondary from './svgs/YesGlyphSecondary.js';
import SvgYesGlyph from './svgs/YesGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var yesGlyph = (props => useIcon(SvgYesGlyph, SvgYesGlyphSecondary, props));

export { yesGlyph as default };
